import jquery from 'jquery';
import myD3 from '../utils/d3.v3';
import myUnderscore from '../utils/underscore-umd-min';
import lodash from 'lodash';
import '../scss/front-modules.scss';
import '../utils/dataTables.bootstrap4.min.css';
import '../utils/themes/base/jquery-ui.css';
import '../utils/themes/smoothness/jquery-ui.css';
window.jQuery = window.$ = jquery;
window.d3 = myD3;
window._ = myUnderscore;
window.lodash = lodash;
